/**
 * Saves the sourcecode to a cookie
 */
const saveSourceCodeToCookie = (sourcecode) => {
  Cookies.set("sourcecode", sourcecode, { expires: 10 });
};

export default saveSourceCodeToCookie;
